import { useCallback } from 'react';
import { fetchCustomerOptions } from '../utils/api';
import { useFetch } from './use-fetch';

const useCustomerOptions = (csrfToken: string) => {
    const fetcher = useCallback(() => {
        return fetchCustomerOptions(csrfToken);
    }, [csrfToken]);

    const { data, error, loading } = useFetch(fetcher);

    return { lineStatuses: data?.line_statuses ?? [], error, loading };
};

export default useCustomerOptions;
